import { useSelector } from "react-redux";
import { DocumentFormulierOrganism, DossierFormulierOrganism } from "..";
import { StepName } from "../../../models/stepper";
import { selectStepper } from "../../../store/selectors";
import { StepperConfig } from "../../../utils/stepperconfig";
import { PublicatieTypeMolecule } from "../../molecules";

const componentMap: Record<StepName, React.ComponentType> = {
  "Kies type": PublicatieTypeMolecule,
  "Dossier maken": DossierFormulierOrganism,
  "Documenten toevoegen": DocumentFormulierOrganism,
  Vervolg: DocumentFormulierOrganism,
};

export function PublicatieStepsContentOrganism() {
  const { currentStep } = useSelector(selectStepper);
  const steps = useSelector(StepperConfig);

  const key = steps[currentStep];
  const Component = componentMap[key];

  return (
    <div>
      <Component />
    </div>
  );
}
